import { render, staticRenderFns } from "./edit-bulk-message-recipient.vue?vue&type=template&id=16d182e8&scoped=true&"
import script from "./edit-bulk-message-recipient.vue?vue&type=script&lang=js&"
export * from "./edit-bulk-message-recipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d182e8",
  null
  
)

export default component.exports